<template>
    <div class="loader-wrapper" v-if="loading">
      <div class="loader"></div>
    </div>
    <section class="authentication-form" v-else>
      <div class="innerpage-decor">
        <div class="innerpage-circle1"><img :src='"../assets/images/Testimonial2.png"' alt=""></div>
        <div class="innerpage-circle2"><img :src='"../assets/images/Testimonial1.png"' alt=""></div>
      </div>
      <div class="text-center">
        <img class="img-logo mx-auto mb-2" :src='"../assets/images/fmce-logo.png"' alt="">
        <h2 class="title text-center mb-0"><span>Self Service</span></h2>
        <p class="text-center">Self Service Menu</p>
        <div class="card card-lg shadow px-5 py-6">
          <h3 class="text-center mt-0 mb-0 text-uppercase">Welcome {{ currentPatient.full_name }},</h3>
          <h3 class="text-center mt-0 text-uppercase">What would you like to do today ?</h3>
          <div class="row mt-4 mb-4">
            <div class="col-md-4 col-sm-12">
              <b-card @click="walletBalance()" class="text-center shadow-lg cursor-pointer">
                <img class="menu-icon" :src='"../assets/images/icon/wallet-balance.png"' alt="">
                <h4 class="line-sm mt-3">Check<br>Wallet Balance</h4>
              </b-card>
            </div>
            <div class="col-md-4 col-sm-12">
              <b-card @click="fundWallet()" class="text-center shadow-lg cursor-pointer">
                <img class="menu-icon" :src='"../assets/images/icon/fund-wallet.png"' alt="">
                <h4 class="line-sm mt-3">Fund<br>Your Wallet</h4>
              </b-card>
            </div>
            <!-- <div class="col">
              <b-card @click="payBill()" class="text-center shadow-lg cursor-pointer">
                <img class="menu-icon" :src='"../assets/images/icon/pay-bill.png"' alt="">
                <h4 class="line-sm mt-3">Pay<br>Hospital Bill</h4>
              </b-card>
            </div> -->
            <div class="col-md-4 col-sm-12">
              <b-card @click="bookAppointment()" class="text-center shadow-lg cursor-pointer">
                <img class="menu-icon" :src='"../assets/images/icon/calendar.png"' alt="">
                <h4 class="line-sm mt-3">Book<br>An Appointment</h4>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-card @click="cancel()" class="text-center shadow-lg cursor-pointer">
                <img class="menu-icon" :src='"../assets/images/icon/exit.png"' alt="">
                <h4 class="line-sm mt-3">EXIT SELF SERVICE</h4>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { mapGetters } from 'vuex'
import { PURGE_PATIENT } from '@/store/welcome.module'

export default {
  name: 'Menu',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['currentPatient'])
  },
  mounted () {},
  methods: {
    walletBalance () {
      let msg = `Your Wallet Balance Is ₦${(this.currentPatient.wallet_balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
      this.$swal({
        title: 'Successful',
        text: msg,
        icon: 'success',
        heightAuto: false
      })
    },
    bookAppointment () {
      this.$swal({
        title: 'Coming Soon',
        text: 'This feature is coming soon',
        icon: 'warning',
        heightAuto: false
      })
    },
    fundWallet () {
      this.$router.push({ name: 'FundWallet' })
    },
    payBill () {
      this.$router.push({ name: 'Bill' })
    },
    cancel () {
      this.loading = true
      this.$store.dispatch(PURGE_PATIENT)
        .then(response => {
          this.loading = false
          this.$router.push({ name: 'Welcome' })
        })
        .catch(error => {
          this.loading = false
          this.$swal({
            title: 'An Error Occured',
            text: error.message,
            icon: 'error',
            heightAuto: false
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/menu.vue